// extracted by mini-css-extract-plugin
export default {"container":"styles_container__aq17p","loader":"styles_loader__Rtcf2"};